import _ from "lodash"

export type ActivationState = "active" | "inactive" | "pending"

export const activationStates: ActivationState[] = ["active", "inactive", "pending"]

export const selectActivationStates = activationStates.map(state => {
    return { value: state, label: _.capitalize(state) }
})
